import React from "react";
import {BaseUploadModal} from "./BaseUploadModal";
import {IMAGE_UPLOAD_TYPE} from "../../ReclasificacionIngresosForm";

export const ModalReporteVentas = ({open, setOpen, image, saveImage, handleImageChange, comment}) => {
    return <BaseUploadModal
        open={open}
        setOpen={setOpen}
        image={image}
        saveImage={saveImage}
        handleImageChange={handleImageChange}
        type={IMAGE_UPLOAD_TYPE.REPORTE_VENTAS}
        comment={comment}
    />
}